var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"name":"shipment","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('div',{class:{
      'form-control': true,
      'is-select': true,
      'is-invalid': errors.length,
      'vs-wrap-text': true
    }},[_c('v-select',{attrs:{"options":_vm.shippingMethods,"disabled":_vm.disabled,"reduce":function (method) { return method.id; },"placeholder":"Wybierz metodę dostawy","searchable":true,"label":"name"},model:{value:(_vm.shipment_id),callback:function ($$v) {_vm.shipment_id=$$v},expression:"shipment_id"}})],1),_c('div',{staticClass:"invalid-feedback"},[_vm._v(" "+_vm._s(errors[0])+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }